import { config } from '#config/configuration';
import { useAuthStore } from '#stores/auth.store';
import type { NavigationGuard } from 'vue-router';
import { routes } from '../routes';

export const authGuard: NavigationGuard = async (to) => {
  const authStore = useAuthStore();

  if (!authStore.isInitialized) {
    await new Promise<void>((resolve) => {
      const unsubscribe = authStore.$subscribe((_, state) => {
        if (state.isInitialized) {
          unsubscribe();
          resolve();
        }
      });
    });
  }

  if (authStore.hasAuthError) {
    if (to.name !== routes.error.name) {
      return {
        name: routes.error.name,
        state: {
          titleKey: 'authentication.gcs.errorTitle',
          subtitleKey: 'authentication.gcs.errorSubtitle',
          icon: 'lock'
        }
      };
    }
    return true;
  }

  if (
    !authStore.isAuthenticated &&
    // ❗️ Avoid an infinite redirect
    !to.meta.isUnauthenticated &&
    to.name !== routes.error.name
  ) {
    const loginPath = config.login.apiLoginPath;

    if (!loginPath) {
      // Fallback behavior: Configuration missing, route internally to error page without a hard reload
      return { name: routes.error.name };
    }

    // Intended behavior: Kick out to external login API (e.g., /api/auth/login)
    globalThis.location.assign(loginPath);
    return false;
  }
};
